"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _classnames = _interopRequireDefault(require("classnames"));

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIViewController = _interopRequireDefault(require("UIComponents/input/UIViewController"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H5"));

var _dates = require("MeetingsBase/constants/dates");

var _BookInfoSelectors = require("MeetingsLib/selectors/BookInfoSelectors");

var _FormActions = require("MeetingsLib/redux/actions/FormActions");

var DurationPicker = (0, _createReactClass.default)({
  propTypes: {
    // loaded
    durationOptions: _propTypes.default.instanceOf(_immutable.List).isRequired,
    selectedDuration: _propTypes.default.number.isRequired,
    setEventDuration: _propTypes.default.func.isRequired
  },
  handleSetEventDuration: function handleSetEventDuration(_ref) {
    var value = _ref.target.value;
    this.props.setEventDuration(value);
  },
  getCompoundTime: function getCompoundTime(hours, minutes) {
    var hourString = _I18n.default.text('prebook.durationPicker.shortHourCount', {
      count: Math.floor(hours)
    });

    var minuteString = _I18n.default.text('prebook.durationPicker.minuteCount', {
      count: minutes
    });

    return _I18n.default.text('prebook.durationPicker.combination', {
      hours: hourString,
      minutes: minuteString
    });
  },
  getHours: function getHours(hours) {
    return _I18n.default.text('prebook.durationPicker.hourCount', {
      count: hours
    });
  },
  getMinutes: function getMinutes(minutes) {
    return _I18n.default.text('prebook.durationPicker.minuteCount', {
      count: minutes
    });
  },
  getDurationOptionText: function getDurationOptionText(duration) {
    var minutes = _I18n.default.moment.duration(duration).asMinutes();

    if (duration >= _dates.ONE_HOUR) {
      var remainderMinutes = _I18n.default.moment.duration(minutes % 60).valueOf();

      var hours = _I18n.default.moment.duration(duration).asHours();

      if (remainderMinutes !== 0) {
        return this.getCompoundTime(hours, remainderMinutes);
      } else {
        return this.getHours(hours);
      }
    }

    return this.getMinutes(minutes);
  },
  getButtonGroupOptions: function getButtonGroupOptions(durationOptions) {
    var _this = this;

    return durationOptions.map(function (duration) {
      return {
        text: _this.getDurationOptionText(duration),
        value: duration
      };
    }).toJS();
  },
  renderDurationPicker: function renderDurationPicker(durationOptions) {
    var buttonGroupOptions = this.getButtonGroupOptions(durationOptions);
    var classes = (0, _classnames.default)('duration-picker width-100', {
      single: durationOptions.size === 1
    });
    return _react.default.createElement("div", {
      className: classes
    }, _react.default.createElement(_H.default, {
      id: "meeting-duration"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "prebook.durationPicker.header"
    })), _react.default.createElement(_UIViewController.default, {
      "aria-labelledby": "meeting-duration",
      className: "display-block",
      value: this.props.selectedDuration,
      onChange: this.handleSetEventDuration,
      defaultValue: durationOptions.first(),
      options: buttonGroupOptions
    }));
  },
  render: function render() {
    var durationOptions = this.props.durationOptions;

    if (!durationOptions || durationOptions.size === 0) {
      return null;
    }

    return this.renderDurationPicker(durationOptions);
  }
});

var _default = (0, _reactRedux.connect)(function (state) {
  return {
    // Rerenders component in response to translation
    activeLocale: state.activeLocale,
    selectedDuration: (0, _BookInfoSelectors.getEvent)(state).duration,
    durationOptions: (0, _BookInfoSelectors.getCustomParams)(state).durations
  };
}, {
  setEventDuration: _FormActions.setEventDuration
})(DurationPicker);

exports.default = _default;
module.exports = exports.default;